<template>
  <div class="ds-save-bar">
    <div
      v-if="$slots.status"
      class="ds-save-bar-status"
    >
      <slot name="status" />
    </div>
    <slot />
  </div>
</template>

<script>
// Sticky action bar pinned to the bottom of a form.
export default {
  name: 'DsSaveBar',
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-save-bar {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 0;
  margin-top: 4px;
  background: $c-bg;
  border-top: 1px solid $c-border;
}

.ds-save-bar-status {
  margin-right: auto;
  font-size: 12px;
  color: $c-text-sec;
}
</style>
